import { useRouteError } from 'react-router-dom'

const ErrorPage = () => {
  const error = useRouteError()
  console.error(error)

  return (
    <main className="min-h-[calc(100vh-200px)]">
      <div className="container px-[15%] pt-14 text-center">
        <div id="error-page">
          <h1 className="mb-4 text-4xl font-bold text-skin-accent">Oops!</h1>
          <p>
            Sorry, an unexpected error has occurred. Please screenshot this page
            and share with the Administrator.
          </p>
          <p>
            <i>{error.statusText || error.message}</i>
          </p>
        </div>
      </div>
    </main>
  )
}

export default ErrorPage
